module.exports = __webpack_public_path__ + "assets1783936157458/img/phone.b971ddec.svg";